import AcUnitOutlinedIcon from "@mui/icons-material/AcUnitOutlined";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import ForestOutlinedIcon from "@mui/icons-material/ForestOutlined";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import HorizontalRuleIcon from "@mui/icons-material/HorizontalRule";
import PropaneTankOutlinedIcon from "@mui/icons-material/PropaneTankOutlined";
import PublicIcon from "@mui/icons-material/Public";
import WaterOutlinedIcon from "@mui/icons-material/WaterOutlined";
import Popover from "@mui/material/Popover";
import PopupState, { bindPopover, bindTrigger } from "material-ui-popup-state";
import queryString from "query-string";
import React, { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useGlobalState } from "../../GlobalStates";
import { useDidMountEffect } from "../../customHooks/useDidMountEffect";
import useQueryParams from "../../customHooks/useQueryParams";
import { useWindowSize } from "../../customHooks/useWindowSize";
import { isNumber } from "../../utils/utils";
import { Filter } from "./Filter/Filter";
import { FilterMobile } from "./Filter/FilterMobile";
import { MenuButton } from "./MenuButton";
import { motion, AnimatePresence } from "framer-motion";
import { Globe } from "lucide-react";
import { useTranslation } from "react-i18next";
import "./header.scss";
import "./header.scss";
import { useIsMobile } from "../../hooks/responsive";
import { dates } from "../../constants/dates";
import authAxios from "../../authAxios";
import { useIsAuthenticated } from "../../utils/auth";
import Modal from "../../components/common/Modal";
import { defaultBroadCategories } from "../../utils/constants";
import { useUserLocale } from "../../customHooks/useUserLocale";
import { communityToCurrencyMap } from "../../utils/multi-language";
import { countryWithLandingPage } from "../../utils/constants";

export const Header = () => {
  const { t } = useTranslation();

  const { community } = useUserLocale();

  const size = useWindowSize();
  const params = useQueryParams();
  const isInApp = window.isInApp;
  const isMobile = useIsMobile();

  const monthParam = params.get("months");
  const destinationParam = params.get("destination");
  const searchParam = params.get("search");

  const navigate = useNavigate();
  const location = useLocation();
  const [sortByHome, setSortByHome] = useGlobalState("sortByHome");
  const [showBroadCategories, setShowBroadCategories] = useGlobalState(
    "showBroadCategories"
  );
  const [user, setUser] = useGlobalState("user");

  const [innerWidth, setInnerWidth] = useState("71rem");
  const [navigateTo, setNavigateTo] = useState("/all-trips");

  const [partner, setPartner] = useState("singapore");

  const showHeader = !(
    location.pathname.startsWith("/affiliate") ||
    location.pathname.startsWith("/request-affiliate") ||
    location.pathname === "/" ||
    location.pathname.includes("sofest-mountain-of-madness") ||
    countryWithLandingPage.includes(location.pathname.replace(/^\//, "")) ||
    location.pathname === "/ideas" ||
    location.pathname === "/inferno" ||
    location.pathname === "/test-calendar" ||
    location.pathname === "/welcome-discount" ||
    location.pathname === "/claim-discount" ||
    location.pathname.startsWith("/campaign") ||
    location.pathname === "/socials" ||
    location.pathname === "/community-page" ||
    location.pathname === "/about" ||
    location.pathname === "/user-review-status" ||
    location.pathname.startsWith("/add-review") ||
    location.pathname === "/404" ||
    location.pathname === "/notif-edit" ||
    location.pathname === "/trip-starter-form" ||
    location.pathname.toLowerCase().includes("project-s") ||
    location.pathname.toLowerCase().includes("login") ||
    location.pathname.toLowerCase().includes("privacy-policy") ||
    location.pathname.toLowerCase().includes("privacy-policy-app") ||
    location.pathname.toLowerCase().includes("terms-app") ||
    location.pathname.toLowerCase().includes("access") ||
    location.pathname.toLowerCase().includes("chat") ||
    (location.pathname.toLowerCase().includes("my-trips") &&
      location.pathname.toLowerCase().includes("action-items")) ||
    (location.pathname.toLowerCase().includes("my-trips") &&
      location.pathname.toLowerCase().includes("itinerary")) ||
    (location.pathname.toLowerCase().includes("my-trips") &&
      location.pathname.toLowerCase().includes("review")) ||
    (location.pathname.toLowerCase().includes("my-trips") &&
      location.pathname.toLowerCase().includes("upload"))
  );

  const [searchMobile, setSearchMobile] = useGlobalState("searchMobile");
  const handleOpenSearchMobile = () => {
    setSearchMobile(true);
  };
  const handleCloseSearchMobile = () => {
    setSearchMobile(false);
  };

  const getLocalPartner = async (url) => {
    let tripId;
    if (
      url === "book" ||
      url === "confirm" ||
      url === "booked" ||
      url === "refund" ||
      url === "reserve"
    ) {
      const query = queryString.parse(location.search);
      tripId = query.trip_id;
    } else if (url === "trips") {
      const params = location.pathname.split("/");
      tripId = params[params.length - 1];
    } else if (url === "trip") {
      const params = location.pathname.split("/");
      tripId = params[params.length - 1];
    }

    // Trip ID should be a number, else we don't fetch
    if (!isNumber(tripId)) {
      return;
    }
  };

  useEffect(() => {
    setShowBroadCategories(defaultBroadCategories(community));

    if (
      location.pathname === "/" ||
      location.pathname === "/mongolia" ||
      location.pathname === "/ideas"
    ) {
      setPartner("singapore");
      setNavigateTo("/");
    } else if (
      location.pathname === "/host" ||
      location.pathname === "/host/" ||
      location.pathname === "/my-trips" ||
      location.pathname === "/my-trips/" ||
      (location.pathname.includes("/all-trips") && location.search !== "")
    ) {
      setPartner("singapore");
      setNavigateTo("/all-trips");
      setInnerWidth("93vw");
    } else if (
      location.pathname === "/all-trips" ||
      location.pathname === "/all-trips/"
    ) {
      setPartner("singapore");
      setNavigateTo("/");
      setInnerWidth("93vw");
    } else if (location.pathname.toLowerCase().includes("host")) {
      setNavigateTo("/host");
      getLocalPartner("trips");
      if (size.width < 1300) {
        setInnerWidth("95vw");
      } else {
        setInnerWidth("72rem");
      }
    } else if (
      location.pathname === "/profile" ||
      location.pathname === "/profile/" ||
      location.pathname === "/notif-edit" ||
      location.pathname === "/notif-edit/"
    ) {
      setPartner("singapore");
      setNavigateTo("/all-trips");
      if (size.width < 1300) {
        setInnerWidth("95vw");
      } else {
        setInnerWidth("76rem");
      }
    } else if (
      location.pathname === "/domore" ||
      location.pathname === "/domore/"
    ) {
      setPartner("singapore");
      setNavigateTo("/all-trips");
      if (size.width < 1300) {
        setInnerWidth("90vw");
      } else {
        setInnerWidth("82vw");
      }
    } else if (
      location.pathname.toLowerCase().includes("trips") ||
      location.pathname.toLowerCase().includes("trip")
    ) {
      setNavigateTo("/all-trips");
      getLocalPartner("trips");
      if (size.width < 1300) {
        setInnerWidth("95vw");
      } else {
        setInnerWidth("72rem");
      }
    } else if (location.pathname.toLowerCase().includes("host")) {
      setNavigateTo("/host");
      getLocalPartner("trips");
      if (size.width < 1300) {
        setInnerWidth("95vw");
      } else {
        setInnerWidth("72rem");
      }
    } else if (
      location.pathname.toLowerCase().includes("book") ||
      location.pathname.toLowerCase().includes("reserve")
    ) {
      setNavigateTo("/all-trips");
      getLocalPartner("book");
      if (size.width < 1300) {
        setInnerWidth("95vw");
      } else {
        setInnerWidth("76rem");
      }
    } else if (
      location.pathname.toLowerCase().includes("confirm") ||
      location.pathname.toLowerCase().includes("booked") ||
      location.pathname.toLowerCase().includes("refund")
    ) {
      setNavigateTo("/all-trips");
      getLocalPartner("confirm");
      if (size.width < 1300) {
        setInnerWidth("95vw");
      } else {
        setInnerWidth("76rem");
      }
    }
  }, [size.width, location.pathname, location.search]);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleProfileClick = () => {
    setAnchorEl(null);
    navigate("/profile");
  };

  const [selectedMonths, setSelectedMonths] = useState([]);
  const [selectedDates, setSelectedDates] = useState([]);
  const [selectedRegion, setSelectedRegion] = useState("");
  const [searchQuery, setSearchQuery] = useState("");

  const handleSelectDates = (date) => {
    if (selectedDates.includes(date)) {
      setSelectedDates(
        selectedDates.filter((selectedDate) => selectedDate !== date)
      );
    } else {
      setSelectedDates([...selectedDates, date]);
    }
  };
  const handleSelectRegion = (region) => {
    if (selectedRegion === region) {
      setSelectedRegion("");
    } else {
      setSelectedRegion(region);
    }
  };
  const handleSelectMonths = (month) => {
    if (selectedMonths.includes(month)) {
      setSelectedMonths(
        selectedMonths.filter((selectedMonth) => selectedMonth !== month)
      );
    } else {
      setSelectedMonths([...selectedMonths, month]);
    }
  };

  // for users that click on filtered link
  const months = params.get("months");
  const destination = params.get("destination");
  useDidMountEffect(() => {
    if (months) {
      const monthsList = months
        .split(",")
        .map((num) => parseInt(num.trim(), 10));

      setSelectedMonths(monthsList);

      const strMonths = [];
      for (const month of monthsList) {
        strMonths.push(dates[month - 1]);
      }

      setSelectedDates(strMonths);
    }

    if (destination) {
      setSelectedRegion(destination);
    }

    if (searchParam) {
      setSearchQuery(searchParam);
    }
  }, [months, destination, searchParam]);

  const handleSearch = (isFilter = false) => {
    setSortByHome("dates");

    const queryParams = new URLSearchParams();

    if (isFilter) {
      // if (countryWithLandingPage.includes(selectedRegion)) {
      //   navigate({
      //     pathname: `/${selectedRegion}`,
      //   });
      //   return;
      // }

      if (selectedMonths.length > 0) {
        queryParams.set("months", selectedMonths);
      }
      if (selectedRegion) {
        queryParams.set("destination", selectedRegion);
      }
    } else {
      queryParams.set("search", searchQuery);
    }

    navigate({
      pathname: "/all-trips",
      search: queryParams.toString(),
    });

    window.scrollTo(0, 0);
  };

  const buildSearchQuery = (broad = "") => {
    const queryParams = new URLSearchParams();

    if (broad) {
      queryParams.set("broad", broad);
    }

    if (monthParam) {
      queryParams.set("months", monthParam);
    }

    if (destinationParam) {
      queryParams.set("destination", destinationParam);
    }

    if (searchParam) {
      queryParams.set("search", searchParam);
    }

    return queryParams.toString() ? `?${queryParams.toString()}` : "";
  };

  const handleClearSelections = () => {
    setSelectedRegion("");
    setSelectedDates([]);
    setSelectedMonths([]);
    setSearchQuery("");
  };

  if (showHeader) {
    return (
      <div className="headerWrapper">
        <header>
          <div
            className="header-inner"
            style={
              isMobile
                ? { width: innerWidth, justifyContent: "center" }
                : {
                    width: innerWidth,
                    justifyContent: "space-between",
                  }
            }
          >
            {!isMobile && (
              <button
                onClick={() => navigate(navigateTo)}
                style={{
                  width: "30%",
                  display: "flex",
                  justifyContent: "flex-start",
                }}
              >
                <div className="tw-grow md:tw-grow-0">
                  {community === "my" ? (
                    <div className="tw-text-white tw-font-bold tw-text-lg tw-flex tw-items-center">
                      {/* <SotravelIcon
                        color="#000"
                        className="tw-h-8 md:tw-h-8 tw-mr-2"
                      /> */}
                      <img
                        src="/new_logo/avider/avider_en_logo.png"
                        style={{
                          height: "18px",
                          margin: "6px",
                        }}
                        alt="Avider En Logo"
                      />
                      <img
                        src="/new_logo/avider/avider_cn_logo.png"
                        style={{ height: "30px", margin: "6px" }}
                        alt="Avider Cn Logo"
                      />

                      {/* <span className="tw-ml-2 tw-text-[deepskyblue] tw-font-extrabold">
                        AVIDER峰狂
                      </span> */}
                    </div>
                  ) : (
                    <img
                      src="/new_logo/horizontal_blue.png"
                      style={{ height: "30px", margin: "8px" }}
                    />
                  )}
                </div>
              </button>
            )}

            {location.pathname === "/all-trips" && (
              <PopupState variant="popover" popupId="demo-popup-popover">
                {(popupState) => (
                  <>
                    {isMobile ? (
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "center",
                          alignContent: "center",
                          paddingTop: "5px",
                          paddingBotom: "4px",
                        }}
                      >
                        <button
                          className="header-search-container"
                          onClick={handleOpenSearchMobile}
                          style={isInApp ? { width: "97%" } : {}}
                        >
                          <div className="header-search-wrapper">
                            <span>
                              {t("anywhere", {
                                defaultValue: "Anywhere",
                              })}
                            </span>
                            <HorizontalRuleIcon
                              style={{ transform: "rotate(90deg)" }}
                            />
                            <span>
                              {t("any_month", {
                                defaultValue: "Any month",
                              })}
                            </span>
                          </div>
                          <SearchIcon
                            style={{ position: "absolute", right: "6px" }}
                            iconWidth="1.2rem"
                            iconHeight="1.2rem"
                          />
                        </button>

                        {!isInApp && (
                          <MenuButton
                            handleClick={handleClick}
                            handleClose={handleClose}
                            anchorEl={anchorEl}
                            handleProfileClick={handleProfileClick}
                            open={open}
                          />
                        )}

                        <FilterMobile
                          selectedDates={selectedDates}
                          handleSelectDates={handleSelectDates}
                          selectedRegion={selectedRegion}
                          handleSelectRegion={handleSelectRegion}
                          searchMobile={searchMobile}
                          handleCloseSearchMobile={handleCloseSearchMobile}
                          handleSelectMonths={handleSelectMonths}
                          handleSearch={handleSearch}
                          handleClearSelections={handleClearSelections}
                          dates={dates}
                          search={searchQuery}
                          onChangeSearch={setSearchQuery}
                        />
                      </div>
                    ) : (
                      <div
                        style={{
                          width: "50%",
                          display: "flex",
                          justifyContent: "center",
                          paddingTop: "5px",
                          paddingBotom: "4px",
                          position: "absolute",
                          left: "50%",
                          transform: "translateX(-50%)",
                        }}
                        {...bindTrigger(popupState)}
                        id="header-search-red-container"
                      >
                        <button className="header-search-container">
                          <div className="header-search-wrapper">
                            <span>
                              {t("anywhere", {
                                defaultValue: "Anywhere",
                              })}
                            </span>
                            <HorizontalRuleIcon
                              style={{ transform: "rotate(90deg)" }}
                            />
                            <span>
                              {t("any_month", {
                                defaultValue: "Any month",
                              })}
                            </span>
                          </div>
                          <SearchIcon
                            style={{ position: "absolute", right: "6px" }}
                            iconWidth="1.2rem"
                            iconHeight="1.2rem"
                          />
                        </button>
                      </div>
                    )}
                    <Popover
                      {...bindPopover(popupState)}
                      anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "center",
                      }}
                      transformOrigin={{
                        vertical: "top",
                        horizontal: "center",
                      }}
                      PaperProps={{
                        sx: {
                          borderRadius: "30px",
                          marginTop: "10px",
                          width: "53rem",
                          maxHeight: "39.125rem",
                        },
                        id: "popoverContainer",
                      }}
                    >
                      <Filter
                        selectedDates={selectedDates}
                        handleSelectDates={handleSelectDates}
                        selectedRegion={selectedRegion}
                        handleSelectRegion={handleSelectRegion}
                        closePopUp={() => popupState.close()}
                        handleSelectMonths={handleSelectMonths}
                        handleSearch={handleSearch}
                        handleClearSelections={handleClearSelections}
                        dates={dates}
                        searchQuery={searchQuery}
                        onChangeSearch={setSearchQuery}
                      />
                    </Popover>
                  </>
                )}
              </PopupState>
            )}

            {!isMobile && (
              <div className="tw-flex tw-items-center tw-gap-2">
                <LanguageSelector />
                <MenuButton
                  handleClick={handleClick}
                  handleClose={handleClose}
                  anchorEl={anchorEl}
                  handleProfileClick={handleProfileClick}
                  open={open}
                />
              </div>
            )}
          </div>
        </header>

        {location.pathname === "/all-trips" && (
          <div className="headerFilter">
            <div
              className="headerFilterContainer"
              style={{ width: innerWidth }}
            >
              <button
                className="headerFilterChoiceContainer"
                style={
                  sortByHome === "dates"
                    ? { color: "black" }
                    : { color: "grey" }
                }
                onClick={() => {
                  setSortByHome("dates");

                  const search = buildSearchQuery();

                  navigate({
                    pathname: "/all-trips",
                    search: search,
                  });
                  window.scrollTo(0, 0);
                }}
              >
                <CalendarMonthOutlinedIcon />
                <span>
                  {t("dates", {
                    defaultValue: "Dates",
                  })}
                </span>
              </button>

              {showBroadCategories["360"] && (
                <button
                  className="headerFilterChoiceContainer"
                  style={
                    sortByHome === "360"
                      ? { color: "black" }
                      : { color: "grey" }
                  }
                  onClick={() => {
                    setSortByHome("360");
                    window.scrollTo(0, 0);

                    const search = buildSearchQuery("360");

                    navigate({
                      pathname: "/all-trips",
                      search: search,
                    });
                  }}
                >
                  <PublicIcon />
                  <span>
                    {t("360", {
                      defaultValue: "360°",
                    })}
                  </span>
                </button>
              )}

              {showBroadCategories.land && (
                <button
                  className="headerFilterChoiceContainer"
                  style={
                    sortByHome === "land"
                      ? { color: "black" }
                      : { color: "grey" }
                  }
                  onClick={() => {
                    setSortByHome("land");
                    window.scrollTo(0, 0);

                    const search = buildSearchQuery("land");

                    navigate({
                      pathname: "/all-trips",
                      search: search,
                    });
                  }}
                >
                  <ForestOutlinedIcon />
                  <span>
                    {t("hike", {
                      defaultValue: "Hike",
                    })}
                  </span>
                </button>
              )}

              {showBroadCategories.snow && (
                <button
                  className="headerFilterChoiceContainer"
                  style={
                    sortByHome === "snow"
                      ? { color: "black" }
                      : { color: "grey" }
                  }
                  onClick={() => {
                    setSortByHome("snow");
                    window.scrollTo(0, 0);

                    const search = buildSearchQuery("snow");

                    navigate({
                      pathname: "/all-trips",
                      search: search,
                    });
                  }}
                >
                  <AcUnitOutlinedIcon />
                  <span>
                    {t("snow", {
                      defaultValue: "Snow",
                    })}
                  </span>
                </button>
              )}

              {showBroadCategories.surf && (
                <button
                  className="headerFilterChoiceContainer"
                  style={
                    sortByHome === "surf"
                      ? { color: "black" }
                      : { color: "grey" }
                  }
                  onClick={() => {
                    setSortByHome("surf");
                    window.scrollTo(0, 0);

                    const search = buildSearchQuery("surf");

                    navigate({
                      pathname: "/all-trips",
                      search: search,
                    });
                  }}
                >
                  <WaterOutlinedIcon />
                  <span>
                    {t("surf", {
                      defaultValue: "Surf",
                    })}
                  </span>
                </button>
              )}

              {showBroadCategories.dive && (
                <button
                  className="headerFilterChoiceContainer"
                  style={
                    sortByHome === "dive"
                      ? { color: "black" }
                      : { color: "grey" }
                  }
                  onClick={() => {
                    setSortByHome("dive");
                    window.scrollTo(0, 0);

                    const search = buildSearchQuery("dive");

                    navigate({
                      pathname: "/all-trips",
                      search: search,
                    });
                  }}
                >
                  <PropaneTankOutlinedIcon />
                  <span>
                    {t("dive", {
                      defaultValue: "Dive",
                    })}
                  </span>
                </button>
              )}

              {showBroadCategories.club && (
                <button
                  className="headerFilterChoiceContainer"
                  style={
                    sortByHome === "club"
                      ? { color: "black" }
                      : { color: "grey" }
                  }
                  onClick={() => {
                    setSortByHome("club");
                    window.scrollTo(0, 0);

                    const search = buildSearchQuery("club");

                    navigate({
                      pathname: "/all-trips",
                      search: search,
                    });
                  }}
                >
                  <FavoriteBorderIcon />
                  <span>
                    {t("club", {
                      defaultValue: "Club",
                    })}
                  </span>
                </button>
              )}
            </div>
          </div>
        )}
      </div>
    );
  }
};

export function SearchIcon({ style, iconWidth, iconHeight }) {
  return (
    <motion.div
      style={{
        width: "2rem",
        height: "2rem",
        background: "deepskyblue",
        borderRadius: "50%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        ...style,
      }}
    >
      <SearchOutlinedIcon
        style={{
          color: "white",
          width: iconWidth,
          height: iconHeight,
        }}
      />
    </motion.div>
  );
}

function LanguageSelector() {
  const [languageModalOpen, setLanguageModalOpen] = useState(false);
  const { t } = useTranslation();

  const [user] = useGlobalState("user");

  return (
    <motion.div className="tw-relative">
      {user.is_admin && (
        <button
          onClick={() => setLanguageModalOpen(true)}
          className="tw-p-2 tw-rounded-full hover:tw-bg-gray-100 tw-transition-colors"
          aria-label={t("preferences.change_language", "Change language")}
        >
          <Globe className="tw-w-5 tw-h-5" />
        </button>
      )}
      <LanguagePortal
        languageModalOpen={languageModalOpen}
        onHide={() => setLanguageModalOpen(false)}
      />
    </motion.div>
  );
}

function getCommunityDefaultLang(community) {
  if (community === "sg") return "en";

  if (community === "my") return "zh-Hans-CN";

  if (community === "tw") return "zh-Hant-TW";

  return "en";
}

export function LanguagePortal({ languageModalOpen, onHide }) {
  const { community: globalCommunity, handleChangeLocale } = useUserLocale();

  const isMobile = useIsMobile();
  const { i18n, t } = useTranslation();
  const modalRef = React.useRef();
  const [activeTab, setActiveTab] = useState("language");
  const [user] = useGlobalState("user");

  const [community, setCommunity] = useState(globalCommunity);

  useEffect(() => {
    setCommunity(globalCommunity);
  }, [globalCommunity, languageModalOpen]);

  const { isAuthenticated } = useIsAuthenticated();

  const getDefaultPreferredLanguage = useCallback(() => {
    if (user?.preferred_language) {
      return user.preferred_language;
    }
    return i18n.language;
  }, [i18n.language, user?.preferred_language]);

  const [preferredLanguage, setPreferredLanguage] = useState(
    getDefaultPreferredLanguage()
  );

  const [isSaving, setIsSaving] = useState(false);

  const resetState = useCallback(() => {
    setPreferredLanguage(getDefaultPreferredLanguage());
    setCommunity(globalCommunity);
    setActiveTab("language");
  }, [getDefaultPreferredLanguage, globalCommunity]);

  // Reset states when user changes or language changes
  useEffect(() => {
    resetState();
  }, [languageModalOpen, resetState]);

  const handleCloseCommunitySettings = useCallback(() => {
    resetState();
    onHide();
  }, [resetState, onHide]);

  const handleSaveCommunitySettings = useCallback(async () => {
    // Validate if all required fields are selected
    if (!preferredLanguage || !community) {
      return; // Don't proceed if required fields are missing
    }

    setIsSaving(true);

    // Store language change info but don't apply it yet
    const hasChangedPreferred =
      (preferredLanguage && preferredLanguage !== i18n.language) ||
      community !== globalCommunity;

    try {
      if (isAuthenticated) {
        // Update user preferences in backend
        await authAxios.post("/v1/user/updateUserPreferredLanguages", {
          preferred_language: preferredLanguage,
          community: community,
        });
      }

      // Only after API call is complete, apply language change if needed
      if (hasChangedPreferred) {
        localStorage.setItem("locale", preferredLanguage);
        localStorage.setItem("community", community);
        localStorage.setItem("currency", communityToCurrencyMap[community]);

        if (window.isInApp) {
          window.postMessage(`locale:${preferredLanguage}`);
          window.postMessage(`community:${community}`);
          window.postMessage(`currency:${communityToCurrencyMap[community]}`);
          onHide();
        } else {
          onHide();
          window.location.reload();
        }
      }

      onHide();
    } catch (error) {
      console.error("Error updating user preferred languages:", error);
    } finally {
      setIsSaving(false);
    }
  }, [
    preferredLanguage,
    community,
    i18n.language,
    isAuthenticated,
    onHide,
    globalCommunity,
  ]);

  const handleCommunityChange = (community) => {
    const defaultLang = getCommunityDefaultLang(community);
    setPreferredLanguage(defaultLang);
    setCommunity(community);

    setActiveTab("language");
  };

  const handleLanguageSelect = (lang) => {
    setPreferredLanguage(lang);
  };

  const disabledSave =
    isSaving ||
    !preferredLanguage ||
    !community ||
    (community === globalCommunity && preferredLanguage === i18n.language);

  const headerContent = (
    <div className="tw-flex tw-items-center tw-justify-between tw-w-full">
      <h2 className="tw-text-xl tw-font-medium tw-text-gray-900">
        {t(
          "preferences.title",
          isMobile ? "Select community" : "Select community and language"
        )}
      </h2>
      <div className="tw-flex tw-flex-col tw-items-end">
        {(!preferredLanguage || !community) && (
          <span className="tw-text-xs tw-text-gray-500 tw-mb-1">
            {t(
              "preferences.select_required",
              "Please select all required fields"
            )}
          </span>
        )}
        <button
          onClick={handleSaveCommunitySettings}
          className={`tw-px-4 tw-py-2 tw-text-white tw-rounded-xl ${
            disabledSave
              ? "tw-bg-gray-400 tw-cursor-not-allowed"
              : "tw-bg-[#00bfff] hover:tw-bg-[#00a6e6]"
          }`}
          disabled={disabledSave}
        >
          {isSaving
            ? t("saving", "Saving...")
            : t("save", { defaultValue: "Save" })}
        </button>
      </div>
    </div>
  );

  const renderLanguageContent = () => {
    return (
      <motion.div
        key="language"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.15 }}
        className="tw-space-y-3 tw-px-6 tw-py-4"
      >
        {/* English option - always show for sg community */}
        {(community === "sg" ||
          community === "my" ||
          community === "tw" ||
          community === "id") && (
          <button
            className={`tw-w-full tw-p-4 tw-rounded-lg tw-flex tw-items-center tw-justify-between tw-transition-colors tw-relative
              ${
                preferredLanguage === "en"
                  ? "tw-bg-gray-50"
                  : "hover:tw-bg-gray-50"
              }`}
            onClick={() => handleLanguageSelect("en")}
          >
            <div className="tw-flex tw-items-center tw-gap-3">
              <Globe className="tw-w-5 tw-h-5" />
              <div className="tw-text-left">
                <div>{t("preferences.english", "English")}</div>
                <div className="tw-text-sm tw-text-gray-500">
                  {t(
                    "preferences.english_desc",
                    "Experience our platform in English"
                  )}
                </div>
              </div>
            </div>
            <div>
              <div
                className={`tw-w-5 tw-h-5 tw-rounded-full tw-border-2 tw-transition-all tw-duration-200 tw-flex tw-items-center tw-justify-center ${
                  preferredLanguage === "en"
                    ? "tw-border-blue-500"
                    : "tw-border-gray-300"
                }`}
              >
                {preferredLanguage === "en" && (
                  <div className="tw-w-2.5 tw-h-2.5 tw-rounded-full tw-bg-blue-500"></div>
                )}
              </div>
            </div>
          </button>
        )}

        {/* Simplified Chinese option - only show for my community */}
        {community === "my" && (
          <button
            className={`tw-w-full tw-p-4 tw-rounded-lg tw-flex tw-items-center tw-justify-between tw-transition-colors tw-relative
              ${
                preferredLanguage === "zh-Hans-CN"
                  ? "tw-bg-gray-50"
                  : "hover:tw-bg-gray-50"
              }`}
            onClick={() => handleLanguageSelect("zh-Hans-CN")}
          >
            <div className="tw-flex tw-items-center tw-gap-3">
              <span className="tw-text-xl">🇲🇾</span>
              <div className="tw-text-left">
                <div>{t("preferences.chinese", "简体中文")}</div>
                <div className="tw-text-sm tw-text-gray-500">
                  {t(
                    "preferences.chinese_desc",
                    "Experience our platform in Simplified Chinese"
                  )}
                </div>
              </div>
            </div>
            <div>
              <div
                className={`tw-w-5 tw-h-5 tw-rounded-full tw-border-2 tw-transition-all tw-duration-200 tw-flex tw-items-center tw-justify-center ${
                  preferredLanguage === "zh-Hans-CN"
                    ? "tw-border-blue-500"
                    : "tw-border-gray-300"
                }`}
              >
                {preferredLanguage === "zh-Hans-CN" && (
                  <div className="tw-w-2.5 tw-h-2.5 tw-rounded-full tw-bg-blue-500"></div>
                )}
              </div>
            </div>
          </button>
        )}

        {/* Traditional Chinese option - only show for tw community */}
        {community === "tw" && (
          <button
            className={`tw-w-full tw-p-4 tw-rounded-lg tw-flex tw-items-center tw-justify-between tw-transition-colors tw-relative
              ${
                preferredLanguage === "zh-Hant-TW"
                  ? "tw-bg-gray-50"
                  : "hover:tw-bg-gray-50"
              }`}
            onClick={() => handleLanguageSelect("zh-Hant-TW")}
          >
            <div className="tw-flex tw-items-center tw-gap-3">
              <span className="tw-text-xl">🇹🇼</span>
              <div className="tw-text-left">
                <div>{t("preferences.traditional_chinese", "繁體中文")}</div>
                <div className="tw-text-sm tw-text-gray-500">
                  {t(
                    "preferences.traditional_chinese_desc",
                    "Experience our platform in Traditional Chinese"
                  )}
                </div>
              </div>
            </div>
            <div>
              <div
                className={`tw-w-5 tw-h-5 tw-rounded-full tw-border-2 tw-transition-all tw-duration-200 tw-flex tw-items-center tw-justify-center ${
                  preferredLanguage === "zh-Hant-TW"
                    ? "tw-border-blue-500"
                    : "tw-border-gray-300"
                }`}
              >
                {preferredLanguage === "zh-Hant-TW" && (
                  <div className="tw-w-2.5 tw-h-2.5 tw-rounded-full tw-bg-blue-500"></div>
                )}
              </div>
            </div>
          </button>
        )}
      </motion.div>
    );
  };

  const renderCommunityContent = () => (
    <motion.div
      key="community"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.15 }}
      className="tw-space-y-3 tw-px-6 tw-py-4"
    >
      <button
        className={`tw-w-full tw-p-4 tw-rounded-lg tw-flex tw-items-center tw-justify-between tw-transition-colors
          ${community === "sg" ? "tw-bg-gray-50" : "hover:tw-bg-gray-50"}`}
        onClick={() => handleCommunityChange("sg")}
      >
        <div className="tw-flex tw-items-center tw-gap-3">
          <span className="tw-text-xl">🇸🇬</span>
          <div className="tw-text-left">
            <div>{t("preferences.singapore", "Singapore")}</div>
            <div className="tw-text-sm tw-text-gray-500">
              {t("preferences.singapore_desc", "Travel with Singaporeans")}
            </div>
          </div>
        </div>
        {community === "sg" && (
          <svg
            className="tw-w-5 tw-h-5 tw-text-blue-600"
            fill="currentColor"
            viewBox="0 0 24 24"
          >
            <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" />
          </svg>
        )}
      </button>

      <button
        className={`tw-w-full tw-p-4 tw-rounded-lg tw-flex tw-items-center tw-justify-between tw-transition-colors
          ${community === "my" ? "tw-bg-gray-50" : "hover:tw-bg-gray-50"}`}
        onClick={() => handleCommunityChange("my")}
      >
        <div className="tw-flex tw-items-center tw-gap-3">
          <span className="tw-text-xl">🇲🇾</span>
          <div className="tw-text-left">
            <div>{t("preferences.malaysia", "Malaysia")}</div>
            <div className="tw-text-sm tw-text-gray-500">
              {t("preferences.malaysia_desc", "Travel with Malaysians")}
            </div>
          </div>
        </div>
        {community === "my" && (
          <svg
            className="tw-w-5 tw-h-5 tw-text-blue-600"
            fill="currentColor"
            viewBox="0 0 24 24"
          >
            <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" />
          </svg>
        )}
      </button>

      <button
        className={`tw-w-full tw-p-4 tw-rounded-lg tw-flex tw-items-center tw-justify-between tw-transition-colors
          ${community === "tw" ? "tw-bg-gray-50" : "hover:tw-bg-gray-50"}`}
        onClick={() => handleCommunityChange("tw")}
      >
        <div className="tw-flex tw-items-center tw-gap-3">
          <span className="tw-text-xl">🇹🇼</span>
          <div className="tw-text-left">
            <div>{t("preferences.taiwan", "Taiwan")}</div>
            <div className="tw-text-sm tw-text-gray-500">
              {t("preferences.taiwan_desc", "Travel with Taiwanese")}
            </div>
          </div>
        </div>
        {community === "tw" && (
          <svg
            className="tw-w-5 tw-h-5 tw-text-blue-600"
            fill="currentColor"
            viewBox="0 0 24 24"
          >
            <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" />
          </svg>
        )}
      </button>

      <button
        className={`tw-w-full tw-p-4 tw-rounded-lg tw-flex tw-items-center tw-justify-between tw-transition-colors
          ${community === "id" ? "tw-bg-gray-50" : "hover:tw-bg-gray-50"}`}
        onClick={() => handleCommunityChange("id")}
      >
        <div className="tw-flex tw-items-center tw-gap-3">
          <span className="tw-text-xl">🇮🇩</span>
          <div className="tw-text-left">
            <div>{t("preferences.indonesia", "Indonesia")}</div>
            <div className="tw-text-sm tw-text-gray-500">
              {t("preferences.indonesia_desc", "Travel with Indonesians")}
            </div>
          </div>
        </div>
        {community === "id" && (
          <svg
            className="tw-w-5 tw-h-5 tw-text-blue-600"
            fill="currentColor"
            viewBox="0 0 24 24"
          >
            <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" />
          </svg>
        )}
      </button>
    </motion.div>
  );

  // Tab header component for both mobile and desktop
  const tabHeader = (
    <div className="tw-border-b">
      <div className="tw-flex tw-items-center tw-px-6 tw-py-2">
        <div className="tw-flex tw-gap-6">
          {user.is_admin && (
            <button
              className={`tw-px-1 tw-py-2 tw-relative ${
                activeTab === "community" ? "tw-text-black" : "tw-text-gray-500"
              }`}
              onClick={() => setActiveTab("community")}
            >
              {t("preferences.community", "Community")}
              {activeTab === "community" && (
                <motion.div
                  className="tw-absolute tw-bottom-0 tw-left-0 tw-right-0 tw-h-0.5 tw-bg-black"
                  layoutId={isMobile ? "activeTab" : "activeTabDesktop"}
                />
              )}
            </button>
          )}

          <button
            className={`tw-px-1 tw-py-2 tw-relative ${
              activeTab === "language" ? "tw-text-black" : "tw-text-gray-500"
            }`}
            onClick={() => setActiveTab("language")}
          >
            {t("preferences.language", "Language")}
            {activeTab === "language" && (
              <motion.div
                className="tw-absolute tw-bottom-0 tw-left-0 tw-right-0 tw-h-0.5 tw-bg-black"
                layoutId={isMobile ? "activeTab" : "activeTabDesktop"}
              />
            )}
          </button>
        </div>
      </div>
    </div>
  );

  // Content based on active tab
  const modalContent = (
    <>
      {tabHeader}
      <AnimatePresence mode="wait">
        {activeTab === "language"
          ? renderLanguageContent()
          : renderCommunityContent()}
      </AnimatePresence>
    </>
  );

  return (
    <AnimatePresence onExitComplete={resetState}>
      <Modal
        open={languageModalOpen}
        onClose={handleCloseCommunitySettings}
        headerContent={headerContent}
        customRef={modalRef}
        zIndex={100001}
        showCloseButton={false}
        position={isMobile ? "bottom" : "center"}
        mobileFullscreen={false}
        maxWidth="xl"
        headerPadding="tw-px-6 tw-pt-6 tw-pb-2"
        bodyPadding="tw-p-0"
      >
        {modalContent}
      </Modal>
    </AnimatePresence>
  );
}
